import { all } from "redux-saga/effects";
import { watchAuction } from "./controllers/onSetAuction";
import { watchLocale } from "./controllers/onSetLocale";
import { watchRequestAuctions, watchRequestAuction } from "./auctions";
import { watchRequestCalendar } from "./calendar";
import { watchRequestCategories } from "./categories";
import { watchRequestContentMenu } from "./contentMenu";
import { watchRequestContentPage } from "./contentPage";
import { watchRequestFeatured } from "./featured";
import { watchRequestLocales } from "./locales";
import { watchRequestTranslations } from "./translations";
import { watchRunMainInit } from "./controllers/main";
import { watchSetPage, watchSetPageFromHistory } from "./page";

export default function* rootSaga() {
  yield all([
    watchAuction(),
    watchLocale(),
    watchRequestAuctions(),
    watchRequestAuction(),
    watchRequestCalendar(),
    watchRequestCategories(),
    watchRequestContentMenu(),
    watchRequestContentPage(),
    watchRequestFeatured(),
    watchRequestLocales(),
    watchRequestTranslations(),
    watchRunMainInit(),
    watchSetPage(),
    watchSetPageFromHistory()
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js